<template>
    <div class="page-menu g3">
        <ul>
            <li class="head">Studies</li>
            <li><router-link :to="createLink('active')">Active</router-link></li>
            <li><router-link :to="createLink('archived')">Archived</router-link></li>
            <li><router-link :to="createLink('study-aggregator')">Study Aggregator</router-link></li>
        </ul>
    </div>
</template>


<script>
    export default {
        methods: {
            createLink(link) {
                if(link === "study-aggregator")
                    return "/aggregation/" + this.$route.params.id + "/0/0";

                return "/program/" + this.$route.params.id + "/" + link;
            }
        }
    }
</script>